import React from 'react';
import { useAuth } from '../hooks/AuthContext';

interface XoroLogoutProps {
  className?: string;
  showTooltip?: boolean;
}

const XoroLogout: React.FC<XoroLogoutProps> = ({ className = "", showTooltip = true }) => {
  const { logout } = useAuth();
  
  const handleLogout = () => {
    logout();
  };

  return (
    <button
      onClick={handleLogout}
      className={`inline-flex items-center justify-center w-10 h-10 bg-gray-200 text-indigo-900/90 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 border border-gray-300/20 ${className}`}
      title={showTooltip ? "Logout" : undefined}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 scale-x-[-1]" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 17v-3H9v-4h7V7l5 5-5 5zM14 2a2 2 0 012 2v2h-2V4H4v16h10v-2h2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h10z"/>
      </svg>
    </button>
  );
};

export default XoroLogout;